import {OPERATOR_COMPARAISON} from './operator.comparaison.model';

/**
 * Toutes les comparaisons qu'une condition d'affichage peut offrir, dans l'ordre où elles se
 * présentent : l'égalité d'abord, puis les comparaisons de grandeur.
 *
 * Aucune condition ne les offre toutes : ce que chacune propose dépend de ce qu'elle observe — c'est
 * la question ou la métadonnée visée qui restreint cette liste. Elle n'est donc jamais posée telle
 * quelle dans un sélecteur, elle sert de référence d'ordre à celles qui en dérivent.
 *
 * Les comparaisons textuelles de l'énumération — `LIKE`, `ILIKE` — n'y figurent pas : elles ne
 * valent que pour du texte libre, qui a sa propre liste.
 */
export const CONDITION_OPERATORS: OPERATOR_COMPARAISON[] = [
    OPERATOR_COMPARAISON.EQUALS,
    OPERATOR_COMPARAISON.NOT_EQUALS,
    OPERATOR_COMPARAISON.GREATER_THAN,
    OPERATOR_COMPARAISON.GREATER_OR_EQUALS,
    OPERATOR_COMPARAISON.LOWER_THAN,
    OPERATOR_COMPARAISON.LOWER_OR_EQUALS,
];
